// 设备列表
export default {
    heard_title: "设备列表",
    btn_add: "新增",
    fl_search: "输入搜索",
    fp_search: "请输入设备名称",
    fl_type: "设备种类",
    fp_type: "请选择种类",
    op_all: "全部",
    op_kart: "卡丁车",
    op_outher: "其他",
    fl_status: "状态:",
    fp_status: "请选择状态",
    op_inUse: "使用中",
    op_notUsed: "未使用",
    op_inRepair: "维修中",
    op_scrapped: "已报废",
    fl_startTime: "购入时间",
    fp_startTime: "请选择开始日期",
    fp_endTime: "请选择结束日期",

    tl_type: "设备种类",
    tl_name: "设备名称",
    tl_number: "设备编号",
    tl_code: "设备ID",
    tl_buyTime: "购入时间",
    tl_status: "状态",

    ft_kart: "卡丁车",
    ft_other: "其他",
    ft_agent: "厂商代理",
    ft_outher: "其他",
    ft_inUse: "使用中",
    ft_notUsed: "未使用",
    ft_inRepair: "维修中",
    ft_scrapped: "已报废"
};
